import React, { PureComponent } from 'react';

import { Endpoint } from '@philips-emr/hpms-stipulator-commons';
import { Accordion, Field, Stamp, StampIcon, Text, Token } from '@philips-emr/tws-components/lib/components';
import { Color, Type } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { eventListener, number, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { HttpService, msg } from '@philips-emr/tws-core/lib/services';

import HpmsMensagemCardApi from '../../api/hpms-mensagem-card-api';
import AttachmentsList from '../attachments-list/attachments-list';
import HpmsCustomCard from '../hpms-custom-card/hpms-custom-card';

import './hpms-mensagem-card.scss';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: HpmsMensagemCardApi })
class HpmsMensagemCard extends PureComponent {

  state = {};

  static propTypes = {
    dsTitulo: string,
    dsTexto: string,
    nrSequencia: number,
    dtLiberacao: string,
    ieLeitura: string,
    ieImportante: string,
    onSelect: eventListener,
    descricao: string,
    ieAnexo: string,
    nrSeqComunicado: number,
  }

  getHeader() {
    const { descricao, ieImportante, ieLeitura, nrSeqComunicado } = this.props;
    return (
      <HpmsCustomCard width={12} key={nrSeqComunicado} showMenu={false} fieldsAreaWidth="100%" className="c-hpms-custom-card__content-wrapper--token-filtro">
        <Field width={9} hideLabel={true}>
          <Stamp icon={StampIcon.CHECK} color={this.getMensagemIconColor(ieLeitura)} label={descricao} className={this.retornaCSS(ieLeitura)} />
        </Field>
        {this.getToken(ieLeitura, ieImportante)}
      </HpmsCustomCard>
    );
  }

  retornaCSS(ieLeitura) {
    return !this.state.ieLeitura && ieLeitura === 'N' ? 'aplicar-bold' : '';
  }

  getToken(ieLeitura, ieImportante) {
    if (!this.state.ieLeitura && ieLeitura === 'N' || ieImportante === 'S') {
      return (
        <Field width={3} hideLabel={true}>
          <Token value={msg(this.getTokenDescricao(ieLeitura))} selected type={this.getTokenType(ieLeitura)} />
        </Field>
      );
    }
    return null;
  }

  getMensagemIconColor(ieLeitura) {
    if (this.state.ieLeitura || ieLeitura == 'S') {
      return Color.SAFETY_GREEN;
    }
    return Color.SAFETY_NEUTRAL;
  }

  getTokenDescricao(ieLeitura) {
    if (!this.state.ieLeitura && ieLeitura === 'N') {
      return 'stipulator.nova';
    }
    return 'stipulator.importante';
  }

  getTokenType(ieLeitura) {
    if (!this.state.ieLeitura && ieLeitura === 'N') {
      return Type.WARNING;
    }
    return Type.DANGER;
  }

  setMensagemLida() {
    const { nrSeqComunicado } = this.props;

    HttpService.post(Endpoint.POST.LEITURA_MENSAGEM, { nrSeqComunicado })
      .then(() => this.setState({ ieLeitura: 'S' }));
    this.getListaAnexos();
  }

  getListaAnexos() {
    const { nrSeqComunicado, onSelect } = this.props;
    HttpService.get(Endpoint.GET.GET_MENSAGEM_ANEXOS, { nrSeqComunicado }).then(response => {
      response.body.map(anexos => {
        anexos.label = anexos.filename;
      });
      this.setState({
        anexos: (<AttachmentsList data={response.body} onSelect={onSelect} />),
      });

    });
  }

  getContent() {
    const { dsTexto, ieAnexo } = this.props;
    return (
      <div>
        <Field hideLabel={true} width={12}>
          <Text value={dsTexto}></Text>
        </Field>
        {this.getAnexos(ieAnexo)}
      </div>
    );
  }

  getAnexos(ieAnexo) {
    if (ieAnexo == 'S') {
      return (
        <div>
          <Text value="Anexos" className="subtitle"></Text>
          <div>
            {this.state.anexos}
          </div>
        </div>
      );
    }
    return null;
  }

  render() {

    return (
      <Accordion width="12" onOpen={() => this.setMensagemLida()} className="c-hpms-mensagem-card" >

          {this.getHeader()}

        <div slot="content">
          {this.getContent()}
        </div>

      </Accordion>
    );
  }
}

export default HpmsMensagemCard;
